import { render, staticRenderFns } from "./ConfigurationTestItem.vue?vue&type=template&id=2f99c3d8"
import script from "./ConfigurationTestItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfigurationTestItem.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports